import AxiosClient from "../../../services/axios.services";

class StatusServices {
  getStatuss = (params) =>
  AxiosClient.get(
    "/api/app/sanciones_estatus/",
    {
      headers: { "Content-Type": "application/json" },
      params: params,
    }
  );

  getStatus = (id) =>
    AxiosClient.get(
    `/api/app/sanciones_estatus/${id}`,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

  saveStatus = (data) =>
    AxiosClient.post(
    "/api/app/sanciones_estatus/",
    data,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

  editStatus = (id, data) =>
    AxiosClient.put(
    `/api/app/sanciones_estatus/${id}/`,
    data,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  
  deleteStatus = (id) =>
    AxiosClient.delete(
    `/api/app/sanciones_estatus/${id}`,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
}

export default new StatusServices();